<template>
  <div style="font-style: italic; padding: 5px 0px; margin-top: 5px;" v-html="message.AttachmentFile.Payload.ErrorMessage"></div>

</template>

<script>
  export default {
    name: 'error-payload',
    data() {
      return {
        message: null
      }
    },
    created() {
      let vm = this;
      vm.message = vm.$parent._props.message
    }
  }

</script>

<style lang="scss" scoped>
</style>




// WEBPACK FOOTER //
// src/components/Messenger/MessageList/Message/MessageAttachment/ErrorPayload.vue